// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ink: #0f2e24;
  --ink-soft: #1a4335;
  --moss: #2f6b52;
  --lime: #d6f06a;
  --lime-deep: #b8d44a;
  --sand: #f3efe6;
  --sand-deep: #e7e0d2;
  --paper: #faf8f3;
  --mist: #dce8e1;
  --text: #15241e;
  --muted: #5a6d64;
  --line: rgba(15, 46, 36, 0.12);
  --danger: #b42318;

  --font-display: 'Roboto', system-ui, sans-serif;
  --font-body: 'Roboto', system-ui, sans-serif;

  --space: clamp(1.25rem, 3vw, 2rem);
  --wide: min(1120px, calc(100% - 2 * var(--space)));
  --radius: 4px;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  min-height: 100vh;
  font-family: var(--font-body);
  font-size: 1.0625rem;
  line-height: 1.6;
  color: var(--text);
  background:
    radial-gradient(1200px 600px at 10% -10%, rgba(214, 240, 106, 0.18), transparent 55%),
    radial-gradient(900px 500px at 100% 0%, rgba(47, 107, 82, 0.12), transparent 50%),
    linear-gradient(180deg, var(--paper) 0%, var(--sand) 45%, var(--paper) 100%);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

img {
  display: block;
  max-width: 100%;
}

a {
  color: inherit;
  text-decoration: none;
}

button,
input,
textarea,
select {
  font: inherit;
}

button {
  cursor: pointer;
}

h1,
h2,
h3,
p {
  margin: 0;
}

#root {
  min-height: 100vh;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(22px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes drift {
  from {
    transform: scale(1.06) translateY(0);
  }
  to {
    transform: scale(1) translateY(-1.5%);
  }
}

@keyframes pulse-line {
  0%,
  100% {
    opacity: 0.35;
  }
  50% {
    opacity: 0.8;
  }
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;;EAEjB,+CAA+C;EAC/C,4CAA4C;;EAE5C,kCAAkC;EAClC,kDAAkD;EAClD,aAAa;AACf;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB;;;gFAG8E;EAC9E,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,oCAAoC;EACtC;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":[":root {\r\n  --ink: #0f2e24;\r\n  --ink-soft: #1a4335;\r\n  --moss: #2f6b52;\r\n  --lime: #d6f06a;\r\n  --lime-deep: #b8d44a;\r\n  --sand: #f3efe6;\r\n  --sand-deep: #e7e0d2;\r\n  --paper: #faf8f3;\r\n  --mist: #dce8e1;\r\n  --text: #15241e;\r\n  --muted: #5a6d64;\r\n  --line: rgba(15, 46, 36, 0.12);\r\n  --danger: #b42318;\r\n\r\n  --font-display: 'Roboto', system-ui, sans-serif;\r\n  --font-body: 'Roboto', system-ui, sans-serif;\r\n\r\n  --space: clamp(1.25rem, 3vw, 2rem);\r\n  --wide: min(1120px, calc(100% - 2 * var(--space)));\r\n  --radius: 4px;\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  min-height: 100vh;\r\n  font-family: var(--font-body);\r\n  font-size: 1.0625rem;\r\n  line-height: 1.6;\r\n  color: var(--text);\r\n  background:\r\n    radial-gradient(1200px 600px at 10% -10%, rgba(214, 240, 106, 0.18), transparent 55%),\r\n    radial-gradient(900px 500px at 100% 0%, rgba(47, 107, 82, 0.12), transparent 50%),\r\n    linear-gradient(180deg, var(--paper) 0%, var(--sand) 45%, var(--paper) 100%);\r\n  -webkit-font-smoothing: antialiased;\r\n  text-rendering: optimizeLegibility;\r\n}\r\n\r\nimg {\r\n  display: block;\r\n  max-width: 100%;\r\n}\r\n\r\na {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\nbutton,\r\ninput,\r\ntextarea,\r\nselect {\r\n  font: inherit;\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\np {\r\n  margin: 0;\r\n}\r\n\r\n#root {\r\n  min-height: 100vh;\r\n}\r\n\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n@keyframes rise {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(22px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes drift {\r\n  from {\r\n    transform: scale(1.06) translateY(0);\r\n  }\r\n  to {\r\n    transform: scale(1) translateY(-1.5%);\r\n  }\r\n}\r\n\r\n@keyframes pulse-line {\r\n  0%,\r\n  100% {\r\n    opacity: 0.35;\r\n  }\r\n  50% {\r\n    opacity: 0.8;\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  html {\r\n    scroll-behavior: auto;\r\n  }\r\n\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
